import {oauthApi} from 'sources/api';

export class ZoomNoteTakerStateResponse {
  uri: string | null;
  state: 'red' | 'green'; // See also StoplightProps. This doesn't have the yellow state.
}

export class RecallZoomIntegrationSource {
  static fetchRecallZoomState(): Promise<ZoomNoteTakerStateResponse> {
    return oauthApi.getJson<ZoomNoteTakerStateResponse>('/zoom_notetaker/state');
  }
}
